/**
 * Метод загрузки модуля для добаления подсказок на элементы
 * @kind helper
 * @returns Промис получения пакета
 */
export const loadHint = () => ymaps3.import('@yandex/ymaps3-hint@0.0.1');
